export enum CollapseStatusEnum {
    EXPANDED = "EXPANDED",
    COLLAPSED = "COLLAPSED"
}

export const getOppositeStatus = (status?: CollapseStatusEnum): CollapseStatusEnum => {
    if (!status) return CollapseStatusEnum.COLLAPSED;

    return status === CollapseStatusEnum.COLLAPSED ? CollapseStatusEnum.EXPANDED : CollapseStatusEnum.COLLAPSED;
};